import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { updateUserAPI } from './api';

const ALL_USERS = 'allUsers';

export function useUpdateUser({ onSuccess } = {}) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();

  const { mutate, isLoading, isSuccess, isError } = useMutation(
    ({ userId, userData }) => updateUserAPI(userId, userData),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ALL_USERS, tenantId]);
        if (onSuccess) {
          onSuccess();
        }
      },
    },
  );

  return {
    updateUser: mutate,
    isLoading,
    isSuccess,
    isError,
  };
}
